/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import SvgBack from '@digital-hig/icon/lib/build/icons/utility/back';
import { useTranslation } from 'react-i18next';
import SecondaryNavigationRootElement from './style';
import { DEFAULT_LANGUAGE } from '../../../constants/app-constants';

const SecondaryNavigation = ({ onBack, backBtnText }) => {
  const { t, i18n: i18next } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(DEFAULT_LANGUAGE);

  useEffect(() => {
    if (i18next.language && selectedLanguage && i18next.language !== selectedLanguage) {
      setSelectedLanguage(i18next.language);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SecondaryNavigationRootElement>
      <Box className="page-container">
        <Box className="secondary-navigation">
          <Box className="left">
            {backBtnText ? (
              <Typography
                data-wat-loc={`${backBtnText === 'Back to Partner Finder' ? 'secondary nav' : 'profile return'}`}
                data-wat-val={`${backBtnText === 'Back to Partner Finder' ? 'anchor link' : 'partner finder'}`}
                onClick={onBack}
                className="title backTitle"
              >
                <SvgBack />
                {t(backBtnText)}
              </Typography>
            ) : (
              <Typography className="title">
                {t('Partner Finder')}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </SecondaryNavigationRootElement>
  );
};

SecondaryNavigation.propTypes = {
  onBack: PropTypes.func,
  backBtnText: PropTypes.string,
};
SecondaryNavigation.defaultProps = {
  onBack: () => {},
  backBtnText: '',
};
export default SecondaryNavigation;
